import { useContext, useState, useRef } from "react";
import { AuthorizedLayout } from "../../components/AuthorizedLayout";
import {
  Box,
  Button,
  Fab,
  Grow,
  Icon,
  IconButton,
  Input,
  LinearProgress,
  linearProgressClasses,
  Rating,
  Typography,
  Modal,
} from "@mui/material";
import useIsMobileDevice from "../../utils/mobileCheck";
import { InputWithLabel } from "../../components/InputWithLabel";
import { useFormik } from "formik";
import profileCharacter from "../../assets/astronaut 3.svg";
import addPhoto from "../../assets/addPhoto.svg";
import { AuthContext } from "../../providers/AuthProvider";
import api from "../../utils/api";
import unmask from "../../utils/unmask";
import { toast } from "react-toastify";
import moment from "moment";
import heart from "../../assets/heartIcon.svg";
import heartInactive from "../../assets/heartIconInactive.svg";
import info from "../../assets/info.svg";
import { useNavigate } from "react-router-dom";
import { Loader } from "../../components/Loader";
import iconSEta from "../../assets/chevron-left.png";
import iconHeart from "../../assets/Vector (23).png";
import astrounautStandingWave from "../../assets/posesPNG/astronout-standing-wave.png";

import astrounautStandingThinking from "../../assets/posesPNG/astronout-standing-thinking.png";
import { ExpandLess, ExpandMore, WhatsApp } from "@mui/icons-material";
import { CompleteProfileCard, useProfileComplete } from "../../components/CompleteProfileCard/CompleteProfileCard";

import "./FAQ.css";
import "../ClientProfile/FlexibleModal.css";

const modalBoxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#F7F7F7",
  border: "1px solid #ABABAB",
  borderRadius: "10px",
  p: "20px",
  minWidth: 320,
  maxWidth: 400,
  width: "90%",
};

const listFac = [
  {
    question: "Eu trabalho com eCommerce! O que vocês tem para mim?",
    answer:
      "Se você é apaixonado por eCommerce, possui habilidades e procura uma oportunidade a eComLovers é o seu ponto de partida! Se inscreva, entre para a comunidade e seja encontrado por empresas que procuram alguém como você!",
  },
  {
    question: "Ah, então vocês são tipo a Catho, Gupy, Vagas…?",
    answer:
      "Não… a eComLovers é diferente. Somos nichados (eCommerce), o que nos torna especialistas. Em nossa comunidade de talentos não temos profissionais de outras áreas. (Salvo que você seja um iniciante que busca empresas para a sua primeira oportunidade).",
  },
  {
    question: "Eu posso me inscrever? Tem restrição?",
    answer:
      "Se você tem qualquer experiência com eCommerce, você já pode se inscrever. E se você nunca trabalhou com nada parecido, mas fez algum curso, ou busca uma oportunidade de primeiro emprego no setor, também pode se inscrever. Então, resumindo, se inscreve sem medo e vem para comunidade dos apaixonados por eCommerce!",
  },
  {
    question: "Me inscrevi! Quando vou ser chamado para uma vaga?",
    answer:
      "No dia seguinte! Brincadeira 😅. Adoraríamos que isso fosse verdade (As vezes será!). Agora você está em nosso banco de talentos e por hora será um prazer ter + 1 Lover com a gente. As vagas vão surgir e vamos tentar colocar você no eCommerce que tiver a melhor sinergia com o seu perfil. O seu perfil ficará disponível para as empresas assinantes encontrar você! Mantenha seu perfil atualizado e terá muito mais chance de ser selecionado.",
  },
  {
    question: "Não vi nenhuma vaga disponível ainda… onde estão?",
    answer:
      "O nosso processo de recrutamento e seleção não é o que você está acostumado… As empresas que possuem vagas, futuras posições e oportunidades em seus negócios digitais vão encontrar você aqui na comunidade. Enriqueça o seu perfil com nossas lives, cursos e eventos e esteja sempre pronto! Lembre-se: A sorte é a oportunidade que encontrou alguém preparado.",
  },
  {
    question: "Eita! Quanto custa isso?",
    answer:
      "Um 🌽! É nada… custa o seu tempo para se inscrever e apenas isso. Ah, se você puder indicar e compartilhar com os profissionais da sua rede de contatos que também são apaixonados por eCommerce, seria uma baita troca, não é mesmo?",
  },
];

export const FAQ = () => {
  const isMobile = useIsMobileDevice();
  const { isProfileComplete } = useProfileComplete();
  const { signOut } = useContext(AuthContext);
  const navigate = useNavigate();
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [requestingDeletion, setRequestingDeletion] = useState(false);
  const [confirmDigits, setConfirmDigits] = useState(Array(6).fill(""));
  const [confirmingDeletion, setConfirmingDeletion] = useState(false);
  const codeInputRefs = useRef([]);

  const QuestionCard = ({ question, answer, renderAnswer }) => {
    const [open, setOpen] = useState(false);

    return (
      <Button
        style={{ textTransform: "none", padding: 0, width: "100%" }}
        color={"inherit"}
        onClick={() => setOpen(!open)}
      >
        <Box
          sx={{
            backgroundColor: "#F7F7F7",
            borderRadius: "10px",
            border: "1px solid #F6F2F3",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-evenly",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "18px",
            }}
          >
            <div className="subtitleFaq3">{question}</div>
            {open ? (
              <ExpandLess style={{ color: "#211E1F", padding: "8px" }} />
            ) : (
              <ExpandMore style={{ color: "#211E1F", padding: "8px" }} />
            )}
          </div>
          <Grow in={open} style={{ transformOrigin: "0 0 0" }}>
            <Box
              sx={{
                padding: "18px",
                background: "#D8F6F5",
                borderRadius: "0px 0px 10px 10px",
                borderTop: "1px solid #BFB7B8",
                display: open ? "flex" : "none",
                flexDirection: "column",
                justifyContent: "space-evenly",
              }}
            >
              {renderAnswer ? (
                <div className="customFaqContent">{renderAnswer()}</div>
              ) : (
                <div className="subtitleFaq2">{answer}</div>
              )}
            </Box>
          </Grow>
        </Box>
      </Button>
    );
  };

  const faqItems = [
    ...listFac,
    {
      question: "Como cancelar minha conta?",
      renderAnswer: () => (
        <CancelAccountContent
          onRequestCode={() => handleDeleteAccountRequest()}
          loading={requestingDeletion}
        />
      ),
    },
  ];

  const handleDeleteAccountRequest = async () => {
    setRequestingDeletion(true);

    try {
      const response = await api.post("/talents/account/request-deletion");

      if (response.data.success) {
        toast.success(
          "Código enviado! Confira seu email e use o código de 6 dígitos para confirmar."
        );
        setConfirmDigits(Array(6).fill(""));
        setShowCancelModal(true);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        toast.error("Você precisa estar logado para desativar sua conta.");
        signOut();
      } else {
        toast.error("Erro ao solicitar desativação. Tente novamente.");
      }
    } finally {
      setRequestingDeletion(false);
    }
  };

  const closeCancelModal = () => {
    if (requestingDeletion || confirmingDeletion) return;
    setShowCancelModal(false);
    setConfirmDigits(Array(6).fill(""));
  };

  const handleConfirmDeletion = async () => {
    const codeValue = confirmDigits.join("");
    const isCodeComplete = confirmDigits.every((digit) => digit !== "");

    if (!isCodeComplete) {
      toast.error("Digite o código de 6 dígitos enviado para o seu email.");
      return;
    }

    setConfirmingDeletion(true);

    try {
      const response = await api.post("/talents/account/confirm-deletion", {
        code: codeValue,
      });

      if (response.data.success) {
        toast.success(response.data.message);
        setShowCancelModal(false);
        setConfirmDigits(Array(6).fill(""));
        signOut();
        navigate("/talents");
      }
    } catch (error) {
      if (error.response?.status === 404) {
        toast.error("Código inválido ou já utilizado.");
      } else if (error.response?.status === 422) {
        toast.error("Código expirado. Solicite um novo.");
      } else if (error.response?.status === 403) {
        toast.error("Este código não pertence à sua conta.");
      } else {
        toast.error("Erro ao confirmar desativação. Tente novamente.");
      }
    } finally {
      setConfirmingDeletion(false);
    }
  };

  const handleDigitChange = (index, rawValue) => {
    const value = rawValue.replace(/[^0-9]/g, "").slice(-1);

    setConfirmDigits((prev) => {
      const next = [...prev];
      next[index] = value;
      return next;
    });

    if (value && index < 5) {
      const nextInput = codeInputRefs.current[index + 1];
      nextInput?.focus();
      nextInput?.select();
    }
  };

  const handleDigitKeyDown = (index, event) => {
    if (event.key === "Backspace") {
      if (confirmDigits[index]) {
        setConfirmDigits((prev) => {
          const next = [...prev];
          next[index] = "";
          return next;
        });
      } else if (index > 0) {
        const previousInput = codeInputRefs.current[index - 1];
        previousInput?.focus();
        previousInput?.select();
        setConfirmDigits((prev) => {
          const next = [...prev];
          next[index - 1] = "";
          return next;
        });
      }
    }

    if (event.key === "ArrowLeft" && index > 0) {
      codeInputRefs.current[index - 1]?.focus();
    }

    if (event.key === "ArrowRight" && index < 5) {
      codeInputRefs.current[index + 1]?.focus();
    }
  };

  const handleCodePaste = (event) => {
    event.preventDefault();
    const pastedText = event.clipboardData
      .getData("text")
      .replace(/[^0-9]/g, "")
      .slice(0, 6);

    if (!pastedText) return;

    const digits = Array(6)
      .fill("")
      .map((_, index) => pastedText[index] || "");

    setConfirmDigits(digits);

    const targetIndex = pastedText.length - 1;
    if (targetIndex >= 0 && codeInputRefs.current[targetIndex]) {
      codeInputRefs.current[targetIndex]?.focus();
      codeInputRefs.current[targetIndex]?.select();
    }
  };

  return (
    <AuthorizedLayout>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "0px 20px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: "20px",
            width: isMobile ? "90vw" : "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "100%",
              flexDirection: "column",
            }}
          >
            <CompleteProfileCard />

            {isProfileComplete && (
              <Box
                sx={{
                  backgroundColor: "#D8F6F5",
                  // border: "1px solid #57BAB8",
                  borderRadius: "10px",
                  width: "100%",
                  aspectRatio: 350 / 115,
                  display: "flex",
                  position: "relative",
                }}
              >
                <Box
                  sx={{
                    height: "100%",
                    width: "60%",
                    padding: "24px",
                  }}
                >
                  <div className="titleFaq">Perguntas Frequentes</div>
                  <div className="subtitleFaq">Tem alguma dúvida?</div>
                  <div className="subtitleFaq">A gente te explica!</div>
                </Box>

                <div
                  style={{
                    position: "relative",
                    height: "100%",
                    width: "40%",
                  }}
                >
                  <img
                    src={astrounautStandingThinking}
                    style={{
                      position: "absolute",
                      height: "110%",
                      maxWidth: "100%",
                      objectFit: "contain",
                      top: "40%",
                      left: "45%",
                      transform: "translate(-50%, -50%)",
                    }}
                    alt=""
                  />
                </div>
              </Box>
            )}

          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              gap: "6px",
              justifyContent: "space-around",
            }}
          >
            <Box
              sx={{
                width: "100%",
                marginBottom: "40px",
                gap: "15px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {faqItems.map((item) => (
                <QuestionCard
                  key={item.question}
                  question={item.question}
                  answer={item.answer}
                  renderAnswer={item.renderAnswer}
                />
              ))}
              <a
                href="https://wa.me/551152867310"
                target="_blank"
                style={{ textDecoration: "none", textTransform: "none" }}
                rel="noreferrer"
              >
                <button className="cardWhatsapp">
                  Ainda tem dúvidas? Vamos conversar!
                </button>
              </a>
            </Box>
          </div>
        </div>
        {/* <Button
          sx={{
            bottom: "20px",
            right: "20px",
            position: "fixed",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            backgroundColor: "#25d366",
            minWidth: 0,
            padding: isMobile ? 1 : 0.5,

            "&:hover": {
              opacity: "75%",
              backgroundColor: "#25d366",
            },
          }}
          href="https://wa.me/5511952939526"
          target="_blank"
        >
          <WhatsApp
            sx={{
              color: "white",
              width: isMobile ? "50px" : "25px",
              height: isMobile ? "50px" : "25px",
            }}
          />
        </Button> */}
      </div>
      <div className="footerMobile">
        Desenvolvido com
        <img src={iconHeart} alt="" />
        <strong>© eComLovers®</strong>
      </div>
      <Modal open={showCancelModal} onClose={closeCancelModal}>
        <Box sx={{ ...modalBoxStyle, display: "flex", flexDirection: "column", gap: "20px" }} className="modalInput">
          <h2 style={{ margin: 0 }}>Desativar conta</h2>
          <div className="faqModalBody">
            <p style={{ margin: 0 }}>
              Enviamos um código de 6 dígitos para o email cadastrado. Confirme
              aqui para finalizar a desativação.
            </p>
            <div className="faqCodeGroup" onPaste={(event) => handleCodePaste(event)}>
              {confirmDigits.map((digit, index) => (
                <input
                  key={index}
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]"
                  maxLength={1}
                  className="faqCodeInput"
                  value={digit}
                  data-index={index}
                  disabled={confirmingDeletion}
                  onChange={(event) => handleDigitChange(index, event.target.value)}
                  onKeyDown={(event) => handleDigitKeyDown(index, event)}
                  ref={(element) => {
                    codeInputRefs.current[index] = element;
                  }}
                />
              ))}
            </div>
            <small className="faqCodeHint" style={{ margin: 0 }}>
              O código expira em 24 horas. Depois de confirmar, sua conta fica
              inativa por 90 dias e pode ser reativada fazendo login.
            </small>
          </div>
          <div className="faqModalActions" style={{ alignSelf: "stretch" }}>
            <button
              className="faqModalButton cancel"
              onClick={closeCancelModal}
              disabled={confirmingDeletion}
            >
              Cancelar
            </button>
            <button
              className="faqModalButton confirm"
              onClick={handleConfirmDeletion}
              disabled={
                confirmingDeletion ||
                !confirmDigits.every((digit) => digit !== "")
              }
            >
              {confirmingDeletion ? "Enviando..." : "Desativar"}
            </button>
          </div>
        </Box>
      </Modal>
    </AuthorizedLayout>
  );
};

const CancelAccountContent = ({ onRequestCode, loading }) => {
  return (
    <div className="cancelAccountWrapper">
      <div className="subtitleFaq2">
        O cancelamento exige um código enviado para o email que você usa na
        plataforma. Clique abaixo para solicitar o código e finalizar o processo.
      </div>
      <button
        className="cancelAccountPrimaryButton"
        onClick={onRequestCode}
        disabled={loading}
      >
        {loading ? "Enviando código..." : "Cancelar conta"}
      </button>
      <p className="cancelAccountHint">
        Se mudar de ideia dentro de 90 dias, basta fazer login para reativar a
        conta automaticamente.
      </p>
    </div>
  );
};
